var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeasuringInchesBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1632,
    height: 332,
    viewBox: "0 0 1632 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7586_28625)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1632,
    height: 332,
    rx: 32,
    fill: "#023047"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7586_28625",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -20,
    y: -473,
    width: 1673,
    height: 1673
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1652.32 -472.77H-20V1199.55H1652.32V-472.77Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7586_28625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.501 12.5501V-76.3371L128.524 -120.777L51.5469 -76.3371V12.5501L128.524 56.9903L205.501 12.5501Z",
    fill: "url(#paint0_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.501 12.5501V-76.3371L128.524 -120.777L51.5469 -76.3371V12.5501L128.524 56.9903L205.501 12.5501Z",
    fill: "url(#paint1_radial_7586_28625)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.454 12.5501V-76.3371L282.477 -120.777L205.5 -76.3371V12.5501L282.477 56.9903L359.454 12.5501Z",
    fill: "url(#paint2_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.454 12.5501V-76.3371L282.477 -120.777L205.5 -76.3371V12.5501L282.477 56.9903L359.454 12.5501Z",
    fill: "url(#paint3_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.415 12.5501V-76.3371L436.438 -120.777L359.461 -76.3371V12.5501L436.438 56.9903L513.415 12.5501Z",
    fill: "url(#paint4_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.415 12.5501V-76.3371L436.438 -120.777L359.461 -76.3371V12.5501L436.438 56.9903L513.415 12.5501Z",
    fill: "url(#paint5_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M667.344 12.5501V-76.3371L590.367 -120.777L513.391 -76.3371V12.5501L590.367 56.9903L667.344 12.5501Z",
    fill: "url(#paint6_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.344 12.5501V-76.3371L590.367 -120.777L513.391 -76.3371V12.5501L590.367 56.9903L667.344 12.5501Z",
    fill: "url(#paint7_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M821.313 12.5501V-76.3371L744.336 -120.777L667.359 -76.3371V12.5501L744.336 56.9903L821.313 12.5501Z",
    fill: "url(#paint8_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.313 12.5501V-76.3371L744.336 -120.777L667.359 -76.3371V12.5501L744.336 56.9903L821.313 12.5501Z",
    fill: "url(#paint9_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M975.274 12.5501V-76.3371L898.297 -120.777L821.32 -76.3371V12.5501L898.297 56.9903L975.274 12.5501Z",
    fill: "url(#paint10_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.274 12.5501V-76.3371L898.297 -120.777L821.32 -76.3371V12.5501L898.297 56.9903L975.274 12.5501Z",
    fill: "url(#paint11_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1129.21 12.5501V-76.3371L1052.23 -120.777L975.258 -76.3371V12.5501L1052.23 56.9903L1129.21 12.5501Z",
    fill: "url(#paint12_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.21 12.5501V-76.3371L1052.23 -120.777L975.258 -76.3371V12.5501L1052.23 56.9903L1129.21 12.5501Z",
    fill: "url(#paint13_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1283.17 12.5501V-76.3371L1206.2 -120.777L1129.22 -76.3371V12.5501L1206.2 56.9903L1283.17 12.5501Z",
    fill: "url(#paint14_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.17 12.5501V-76.3371L1206.2 -120.777L1129.22 -76.3371V12.5501L1206.2 56.9903L1283.17 12.5501Z",
    fill: "url(#paint15_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1437.12 12.5501V-76.3371L1360.14 -120.777L1283.16 -76.3371V12.5501L1360.14 56.9903L1437.12 12.5501Z",
    fill: "url(#paint16_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.12 12.5501V-76.3371L1360.14 -120.777L1283.16 -76.3371V12.5501L1360.14 56.9903L1437.12 12.5501Z",
    fill: "url(#paint17_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1591.09 12.5501V-76.3371L1514.11 -120.777L1437.13 -76.3371V12.5501L1514.11 56.9903L1591.09 12.5501Z",
    fill: "url(#paint18_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.09 12.5501V-76.3371L1514.11 -120.777L1437.13 -76.3371V12.5501L1514.11 56.9903L1591.09 12.5501Z",
    fill: "url(#paint19_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1745.02 12.5501V-76.3371L1668.05 -120.777L1591.07 -76.3371V12.5501L1668.05 56.9903L1745.02 12.5501Z",
    fill: "url(#paint20_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745.02 12.5501V-76.3371L1668.05 -120.777L1591.07 -76.3371V12.5501L1668.05 56.9903L1745.02 12.5501Z",
    fill: "url(#paint21_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.508 412.487V323.6L51.5315 279.156L-25.4453 323.6V412.487L51.5315 456.927L128.508 412.487Z",
    fill: "url(#paint22_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.508 412.487V323.6L51.5315 279.156L-25.4453 323.6V412.487L51.5315 456.927L128.508 412.487Z",
    fill: "url(#paint23_radial_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.477 412.487V323.6L205.5 279.156L128.523 323.6V412.487L205.5 456.927L282.477 412.487Z",
    fill: "url(#paint24_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.477 412.487V323.6L205.5 279.156L128.523 323.6V412.487L205.5 456.927L282.477 412.487Z",
    fill: "url(#paint25_radial_7586_28625)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.438 412.485V323.598L359.461 279.154L282.484 323.598V412.485L359.461 456.925L436.438 412.485Z",
    fill: "url(#paint26_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.438 412.485V323.598L359.461 279.154L282.484 323.598V412.485L359.461 456.925L436.438 412.485Z",
    fill: "url(#paint27_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M590.376 412.485V323.598L513.399 279.154L436.422 323.598V412.485L513.399 456.925L590.376 412.485Z",
    fill: "url(#paint28_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.376 412.485V323.598L513.399 279.154L436.422 323.598V412.485L513.399 456.925L590.376 412.485Z",
    fill: "url(#paint29_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M744.329 412.485V323.598L667.352 279.154L590.375 323.598V412.485L667.352 456.925L744.329 412.485Z",
    fill: "url(#paint30_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.329 412.485V323.598L667.352 279.154L590.375 323.598V412.485L667.352 456.925L744.329 412.485Z",
    fill: "url(#paint31_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M898.29 412.485V323.598L821.313 279.154L744.336 323.598V412.485L821.313 456.925L898.29 412.485Z",
    fill: "url(#paint32_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.29 412.485V323.598L821.313 279.154L744.336 323.598V412.485L821.313 456.925L898.29 412.485Z",
    fill: "url(#paint33_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1052.26 412.485V323.598L975.281 279.154L898.305 323.598V412.485L975.281 456.925L1052.26 412.485Z",
    fill: "url(#paint34_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.26 412.485V323.598L975.281 279.154L898.305 323.598V412.485L975.281 456.925L1052.26 412.485Z",
    fill: "url(#paint35_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1206.19 412.485V323.598L1129.21 279.154L1052.23 323.598V412.485L1129.21 456.925L1206.19 412.485Z",
    fill: "url(#paint36_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.19 412.485V323.598L1129.21 279.154L1052.23 323.598V412.485L1129.21 456.925L1206.19 412.485Z",
    fill: "url(#paint37_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1360.13 412.485V323.598L1283.16 279.154L1206.18 323.598V412.485L1283.16 456.925L1360.13 412.485Z",
    fill: "url(#paint38_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.13 412.485V323.598L1283.16 279.154L1206.18 323.598V412.485L1283.16 456.925L1360.13 412.485Z",
    fill: "url(#paint39_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1514.11 412.485V323.598L1437.13 279.154L1360.16 323.598V412.485L1437.13 456.925L1514.11 412.485Z",
    fill: "url(#paint40_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.11 412.485V323.598L1437.13 279.154L1360.16 323.598V412.485L1437.13 456.925L1514.11 412.485Z",
    fill: "url(#paint41_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1668.07 412.485V323.598L1591.09 279.154L1514.12 323.598V412.485L1591.09 456.925L1668.07 412.485Z",
    fill: "url(#paint42_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1668.07 412.485V323.598L1591.09 279.154L1514.12 323.598V412.485L1591.09 456.925L1668.07 412.485Z",
    fill: "url(#paint43_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.5318 279.159V190.272L-25.4451 145.832L-102.422 190.272V279.159L-25.4451 323.603L51.5318 279.159Z",
    fill: "url(#paint44_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5318 279.159V190.272L-25.4451 145.832L-102.422 190.272V279.159L-25.4451 323.603L51.5318 279.159Z",
    fill: "url(#paint45_radial_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.508 145.872V56.9885L51.5315 12.5449L-25.4453 56.9885V145.872L51.5315 190.316L128.508 145.872Z",
    fill: "url(#paint46_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.508 145.872V56.9885L51.5315 12.5449L-25.4453 56.9885V145.872L51.5315 190.316L128.508 145.872Z",
    fill: "url(#paint47_radial_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.477 145.872V56.9885L205.5 12.5449L128.523 56.9885V145.872L205.5 190.316L282.477 145.872Z",
    fill: "url(#paint48_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.477 145.872V56.9885L205.5 12.5449L128.523 56.9885V145.872L205.5 190.316L282.477 145.872Z",
    fill: "url(#paint49_radial_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.501 279.159V190.272L128.524 145.832L51.5469 190.272V279.159L128.524 323.603L205.501 279.159Z",
    fill: "url(#paint50_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.501 279.159V190.272L128.524 145.832L51.5469 190.272V279.159L128.524 323.603L205.501 279.159Z",
    fill: "url(#paint51_radial_7586_28625)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.454 279.159V190.272L282.477 145.832L205.5 190.272V279.159L282.477 323.603L359.454 279.159Z",
    fill: "url(#paint52_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.454 279.159V190.272L282.477 145.832L205.5 190.272V279.159L282.477 323.603L359.454 279.159Z",
    fill: "url(#paint53_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.438 145.87V56.9865L359.461 12.543L282.484 56.9865V145.87L359.461 190.314L436.438 145.87Z",
    fill: "url(#paint54_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.438 145.87V56.9865L359.461 12.543L282.484 56.9865V145.87L359.461 190.314L436.438 145.87Z",
    fill: "url(#paint55_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M590.376 145.87V56.9865L513.399 12.543L436.422 56.9865V145.87L513.399 190.314L590.376 145.87Z",
    fill: "url(#paint56_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.376 145.87V56.9865L513.399 12.543L436.422 56.9865V145.87L513.399 190.314L590.376 145.87Z",
    fill: "url(#paint57_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.415 279.159V190.272L436.438 145.832L359.461 190.272V279.159L436.438 323.603L513.415 279.159Z",
    fill: "url(#paint58_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.415 279.159V190.272L436.438 145.832L359.461 190.272V279.159L436.438 323.603L513.415 279.159Z",
    fill: "url(#paint59_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M744.329 145.87V56.9865L667.352 12.543L590.375 56.9865V145.87L667.352 190.314L744.329 145.87Z",
    fill: "url(#paint60_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.329 145.87V56.9865L667.352 12.543L590.375 56.9865V145.87L667.352 190.314L744.329 145.87Z",
    fill: "url(#paint61_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M898.29 145.87V56.9865L821.313 12.543L744.336 56.9865V145.87L821.313 190.314L898.29 145.87Z",
    fill: "url(#paint62_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.29 145.87V56.9865L821.313 12.543L744.336 56.9865V145.87L821.313 190.314L898.29 145.87Z",
    fill: "url(#paint63_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M821.313 279.159V190.272L744.336 145.832L667.359 190.272V279.159L744.336 323.603L821.313 279.159Z",
    fill: "url(#paint64_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.313 279.159V190.272L744.336 145.832L667.359 190.272V279.159L744.336 323.603L821.313 279.159Z",
    fill: "url(#paint65_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M667.344 279.159V190.272L590.367 145.832L513.391 190.272V279.159L590.367 323.603L667.344 279.159Z",
    fill: "url(#paint66_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.344 279.159V190.272L590.367 145.832L513.391 190.272V279.159L590.367 323.603L667.344 279.159Z",
    fill: "url(#paint67_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M975.274 279.159V190.272L898.297 145.832L821.32 190.272V279.159L898.297 323.603L975.274 279.159Z",
    fill: "url(#paint68_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.274 279.159V190.272L898.297 145.832L821.32 190.272V279.159L898.297 323.603L975.274 279.159Z",
    fill: "url(#paint69_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1052.26 145.87V56.9865L975.281 12.543L898.305 56.9865V145.87L975.281 190.314L1052.26 145.87Z",
    fill: "url(#paint70_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.26 145.87V56.9865L975.281 12.543L898.305 56.9865V145.87L975.281 190.314L1052.26 145.87Z",
    fill: "url(#paint71_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1206.19 145.87V56.9865L1129.21 12.543L1052.23 56.9865V145.87L1129.21 190.314L1206.19 145.87Z",
    fill: "url(#paint72_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.19 145.87V56.9865L1129.21 12.543L1052.23 56.9865V145.87L1129.21 190.314L1206.19 145.87Z",
    fill: "url(#paint73_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1129.21 279.159V190.272L1052.23 145.832L975.258 190.272V279.159L1052.23 323.603L1129.21 279.159Z",
    fill: "url(#paint74_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.21 279.159V190.272L1052.23 145.832L975.258 190.272V279.159L1052.23 323.603L1129.21 279.159Z",
    fill: "url(#paint75_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1283.17 279.159V190.272L1206.2 145.832L1129.22 190.272V279.159L1206.2 323.603L1283.17 279.159Z",
    fill: "url(#paint76_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.17 279.159V190.272L1206.2 145.832L1129.22 190.272V279.159L1206.2 323.603L1283.17 279.159Z",
    fill: "url(#paint77_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1360.13 145.87V56.9865L1283.16 12.543L1206.18 56.9865V145.87L1283.16 190.314L1360.13 145.87Z",
    fill: "url(#paint78_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.13 145.87V56.9865L1283.16 12.543L1206.18 56.9865V145.87L1283.16 190.314L1360.13 145.87Z",
    fill: "url(#paint79_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1514.11 145.87V56.9865L1437.13 12.543L1360.16 56.9865V145.87L1437.13 190.314L1514.11 145.87Z",
    fill: "url(#paint80_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.11 145.87V56.9865L1437.13 12.543L1360.16 56.9865V145.87L1437.13 190.314L1514.11 145.87Z",
    fill: "url(#paint81_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1437.12 279.159V190.272L1360.14 145.832L1283.16 190.272V279.159L1360.14 323.603L1437.12 279.159Z",
    fill: "url(#paint82_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.12 279.159V190.272L1360.14 145.832L1283.16 190.272V279.159L1360.14 323.603L1437.12 279.159Z",
    fill: "url(#paint83_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1591.09 279.159V190.272L1514.11 145.832L1437.13 190.272V279.159L1514.11 323.603L1591.09 279.159Z",
    fill: "url(#paint84_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.09 279.159V190.272L1514.11 145.832L1437.13 190.272V279.159L1514.11 323.603L1591.09 279.159Z",
    fill: "url(#paint85_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1668.07 145.87V56.9865L1591.09 12.543L1514.12 56.9865V145.87L1591.09 190.314L1668.07 145.87Z",
    fill: "url(#paint86_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1668.07 145.87V56.9865L1591.09 12.543L1514.12 56.9865V145.87L1591.09 190.314L1668.07 145.87Z",
    fill: "url(#paint87_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1745.02 279.159V190.272L1668.05 145.832L1591.07 190.272V279.159L1668.05 323.603L1745.02 279.159Z",
    fill: "url(#paint88_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745.02 279.159V190.272L1668.05 145.832L1591.07 190.272V279.159L1668.05 323.603L1745.02 279.159Z",
    fill: "url(#paint89_radial_7586_28625)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.5318 12.5501V-76.3371L-25.4451 -120.777L-102.422 -76.3371V12.5501L-25.4451 56.9903L51.5318 12.5501Z",
    fill: "url(#paint90_linear_7586_28625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5318 12.5501V-76.3371L-25.4451 -120.777L-102.422 -76.3371V12.5501L-25.4451 56.9903L51.5318 12.5501Z",
    fill: "url(#paint91_radial_7586_28625)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7586_28625",
    x1: 51.5469,
    y1: -31.8937,
    x2: 205.501,
    y2: -31.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.784 -180.661) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7586_28625",
    x1: 205.5,
    y1: -31.8937,
    x2: 359.454,
    y2: -31.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(280.737 -180.661) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7586_28625",
    x1: 359.461,
    y1: -31.8937,
    x2: 513.415,
    y2: -31.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(434.698 -180.661) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7586_28625",
    x1: 513.391,
    y1: -31.8937,
    x2: 667.344,
    y2: -31.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(588.627 -180.661) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7586_28625",
    x1: 667.359,
    y1: -31.8937,
    x2: 821.313,
    y2: -31.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(742.596 -180.661) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7586_28625",
    x1: 821.32,
    y1: -31.8937,
    x2: 975.274,
    y2: -31.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(896.557 -180.661) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7586_28625",
    x1: 975.257,
    y1: -31.8937,
    x2: 1129.21,
    y2: -31.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1050.49 -180.661) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7586_28625",
    x1: 1129.22,
    y1: -31.8937,
    x2: 1283.17,
    y2: -31.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1204.46 -180.661) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7586_28625",
    x1: 1283.16,
    y1: -31.8937,
    x2: 1437.12,
    y2: -31.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1358.4 -180.661) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7586_28625",
    x1: 1437.13,
    y1: -31.8937,
    x2: 1591.09,
    y2: -31.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1512.37 -180.661) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7586_28625",
    x1: 1591.07,
    y1: -31.8937,
    x2: 1745.02,
    y2: -31.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1666.31 -180.661) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7586_28625",
    x1: -25.4453,
    y1: 368.043,
    x2: 128.508,
    y2: 368.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.7915 219.275) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7586_28625",
    x1: 128.523,
    y1: 368.043,
    x2: 282.477,
    y2: 368.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(203.76 219.275) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7586_28625",
    x1: 282.484,
    y1: 368.041,
    x2: 436.438,
    y2: 368.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(357.721 219.273) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7586_28625",
    x1: 436.422,
    y1: 368.041,
    x2: 590.376,
    y2: 368.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(511.659 219.273) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_7586_28625",
    x1: 590.375,
    y1: 368.041,
    x2: 744.328,
    y2: 368.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(665.612 219.273) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_7586_28625",
    x1: 744.336,
    y1: 368.041,
    x2: 898.289,
    y2: 368.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(819.572 219.273) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_7586_28625",
    x1: 898.304,
    y1: 368.041,
    x2: 1052.26,
    y2: 368.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(973.541 219.273) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_7586_28625",
    x1: 1052.23,
    y1: 368.041,
    x2: 1206.19,
    y2: 368.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1127.47 219.273) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_7586_28625",
    x1: 1206.18,
    y1: 368.041,
    x2: 1360.13,
    y2: 368.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1281.42 219.273) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_7586_28625",
    x1: 1360.16,
    y1: 368.041,
    x2: 1514.11,
    y2: 368.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1435.39 219.273) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_7586_28625",
    x1: 1514.12,
    y1: 368.041,
    x2: 1668.07,
    y2: 368.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1589.35 219.273) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_7586_28625",
    x1: -102.422,
    y1: 234.716,
    x2: 51.5318,
    y2: 234.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.185 85.9489) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_7586_28625",
    x1: -25.4453,
    y1: 101.431,
    x2: 128.508,
    y2: 101.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.7915 -47.3365) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_7586_28625",
    x1: 128.523,
    y1: 101.431,
    x2: 282.477,
    y2: 101.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(203.76 -47.3365) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_7586_28625",
    x1: 51.5469,
    y1: 234.716,
    x2: 205.501,
    y2: 234.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.784 85.9489) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_7586_28625",
    x1: 205.5,
    y1: 234.716,
    x2: 359.454,
    y2: 234.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(280.737 85.9489) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_7586_28625",
    x1: 282.484,
    y1: 101.429,
    x2: 436.438,
    y2: 101.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(357.721 -47.3384) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_7586_28625",
    x1: 436.422,
    y1: 101.429,
    x2: 590.376,
    y2: 101.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(511.659 -47.3384) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_7586_28625",
    x1: 359.461,
    y1: 234.716,
    x2: 513.415,
    y2: 234.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(434.698 85.9489) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_7586_28625",
    x1: 590.375,
    y1: 101.429,
    x2: 744.328,
    y2: 101.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(665.612 -47.3384) scale(168.358 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_7586_28625",
    x1: 744.336,
    y1: 101.429,
    x2: 898.289,
    y2: 101.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(819.572 -47.3384) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_7586_28625",
    x1: 667.359,
    y1: 234.716,
    x2: 821.313,
    y2: 234.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(742.596 85.9489) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_7586_28625",
    x1: 513.391,
    y1: 234.716,
    x2: 667.344,
    y2: 234.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(588.627 85.9489) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_7586_28625",
    x1: 821.32,
    y1: 234.716,
    x2: 975.274,
    y2: 234.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(896.557 85.9489) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_7586_28625",
    x1: 898.304,
    y1: 101.429,
    x2: 1052.26,
    y2: 101.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(973.541 -47.3384) scale(168.358 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_7586_28625",
    x1: 1052.23,
    y1: 101.429,
    x2: 1206.19,
    y2: 101.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1127.47 -47.3384) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_7586_28625",
    x1: 975.257,
    y1: 234.716,
    x2: 1129.21,
    y2: 234.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1050.49 85.9489) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_7586_28625",
    x1: 1129.22,
    y1: 234.716,
    x2: 1283.17,
    y2: 234.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1204.46 85.9489) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_7586_28625",
    x1: 1206.18,
    y1: 101.429,
    x2: 1360.13,
    y2: 101.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1281.42 -47.3384) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_7586_28625",
    x1: 1360.16,
    y1: 101.429,
    x2: 1514.11,
    y2: 101.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1435.39 -47.3384) scale(168.358 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_7586_28625",
    x1: 1283.16,
    y1: 234.716,
    x2: 1437.12,
    y2: 234.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1358.4 85.9489) scale(168.358 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_7586_28625",
    x1: 1437.13,
    y1: 234.716,
    x2: 1591.09,
    y2: 234.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1512.37 85.9489) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_7586_28625",
    x1: 1514.12,
    y1: 101.429,
    x2: 1668.07,
    y2: 101.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1589.35 -47.3384) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_7586_28625",
    x1: 1591.07,
    y1: 234.716,
    x2: 1745.02,
    y2: 234.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1666.31 85.9489) scale(168.358 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_7586_28625",
    x1: -102.422,
    y1: -31.8937,
    x2: 51.5318,
    y2: -31.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_7586_28625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.185 -180.661) scale(168.359 168.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01121,
    stopColor: "#808080",
    stopOpacity: 0.98123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23892,
    stopColor: "#808080",
    stopOpacity: 0.63204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45793,
    stopColor: "#808080",
    stopOpacity: 0.35734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66331,
    stopColor: "#808080",
    stopOpacity: 0.16052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84963,
    stopColor: "#808080",
    stopOpacity: 0.04142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7586_28625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1632,
    height: 332,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasuringInchesBg);
export default __webpack_public_path__ + "static/media/measuring_inches_bg.120c168d959dbf6c5e4b1f97fc897eee.svg";
export { ForwardRef as ReactComponent };